import React from "react";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { BookOpen } from "lucide-react";

export default function Programs() {
    const [classes, setClasses] = React.useState([]);
    React.useEffect(() => { api.get("/classes").then(r => setClasses(r.data)).catch(() => { }); }, []);
    return (
        <main className="py-16">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="overline text-brand-stone mb-3">Programs</div>
                <h1 className="font-serif text-5xl text-brand-ink leading-tight max-w-3xl">
                    Every grade, <span className="italic text-primary">every step</span> of the way.
                </h1>
                <p className="mt-5 text-brand-stone max-w-2xl">
                    Our weekend school offers classes for Pre-K through 12th grade, plus dedicated Quran and Arabic tracks.
                </p>
                <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {classes.map((c) => (
                        <Card key={c.id} className="card-lift border-border/70">
                            <CardContent className="p-7">
                                <div className="flex items-start justify-between">
                                    <div className="w-11 h-11 rounded-lg bg-primary/10 text-primary grid place-items-center">
                                        <BookOpen className="w-5 h-5" />
                                    </div>
                                    <Badge variant="secondary" className="bg-accent/10 text-accent border-0">{c.grade}</Badge>
                                </div>
                                <h3 className="mt-5 font-dash text-xl font-semibold text-brand-ink">{c.name}</h3>
                                <p className="mt-2 text-sm text-brand-stone leading-relaxed line-clamp-3">
                                    {c.description || "A warm, engaging class focused on faith, character, and Quran."}
                                </p>
                                <div className="mt-6 pt-5 border-t border-border/60 flex items-center justify-between text-xs text-brand-stone">
                                    <span>{c.schedule}</span>
                                    <span>Room {c.room?.replace("Room ", "") || "TBD"}</span>
                                </div>
                                {c.teacher_name && <div className="mt-3 text-xs text-primary font-medium">Teacher: {c.teacher_name}</div>}
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </div>
        </main>
    );
}
